import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { AppApi } from '@wix/wix-data-client-common'
import type {
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'

export interface ConvertToDynamicCompletePayload {
  routerPrefix: string
  pageId: string
  dataCollectionId: string
}

const getPageRefs = async (
  editorSdkProxy: EditorSDK,
  pageId: string,
): Promise<PageRef[]> => {
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()
  return routers
    .flatMap(router => router.pages)
    .filter(({ pageRef }) => pageRef.id === pageId)
    .map(({ pageRef }) => pageRef)
}

export const onConvertToDynamicComplete = async (
  appApi: AppApi,
  editorSdkProxy: EditorSDK,
  { pageId }: ConvertToDynamicCompletePayload,
): Promise<void> => {
  const pageRefs = await getPageRefs(editorSdkProxy, pageId)
  await appApi.handleChangedRouters({ pageRefs })
}
